module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "c-card"
  }, [_c('header', {
    staticClass: "c-card__header"
  }, [_c('div', {
    staticClass: "c-card__leading"
  }, [_c('h6', {
    staticClass: "c-card__title"
  }, [_vm._v(_vm._s(_vm.definitionModule.name))]), _vm._v(" "), _c('span', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.$t(_vm.definitionModule.type).label))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__control"
  }, [_c('span', {
    class: _vm.definitionModule.module ? 'badge badge--success' : 'badge badge--info',
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.definitionModule.module ? 'Instalado' : 'Disponível'))])])]), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.definitionModule.logo,
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "c-card__footer u-textLeft"
  }, [_c('button', {
    staticClass: "btn btn--smart btn--sm",
    class: _vm.buttonClass,
    attrs: {
      "href": "#",
      "disabled": _vm.definitionModule.module || _vm.installing
    },
    on: {
      "click": _vm.installModule
    }
  }, [_vm._v("\n      " + _vm._s(_vm.definitionModule.module ? 'Instalado' : 'Instalar') + "\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": _vm.definitionModule.site,
      "target": "_blank"
    }
  }, [_vm._v("Ver mais")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-549c3e2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/StoreCard.vue
// module id = 3174
// module chunks = 0